// 引入 HySDK
require('@qnpm/hysdk');
// 引入 插件
require('@qnpm/hysdk-fusion');
let { isWxBrower } = require('./browser');
import shareDialog from '@/components/dialog/share';

/**
 * qunar混合应用公用方法
 */

export function initConfig() {/* qunar混合应用初始化配置 */
  hysdk.config({
    debug: false,
    bridgeReadyEvent: 'WebViewJavascriptBridgeReady',
    bridgeReadyTimeout: 600,
    hytiveReg: '',
    wechatSupport: true,
    wechatScriptUrl: '//res.wx.qq.com/open/js/jweixin-1.0.0.js',
    wechatSignatureUrl: '//ccweixin.qunar.com/chat/getJsConfig.do',
    ucAPIScriptUrl:
      '//common.qunarzz.com/ucapi/prd/scripts/1.0.3/api@d20c312aba29a7178996dd57abcca695.js',
  });
}

/**
 * 
 * @param title 分享标题
 * @param desc 分享描述
 * @param shareImg 分享图片
 */

export function buryingGetPrize() {
  window._hmt.push(["_trackPageview", "/#/Mo_LanCome_GetPrize"]);
  let win = window as any;
  win.gaTracker('Truemetrics.send', 'event', 'LanCome_Index', 'MO', 'Mo_LanCome_GetPrize');
}

export function share(callback?: any) {
  hysdk.onMenuShare({
    title: '一汽红旗H5',
    desc: '旗·敬真我 2020我的城市记忆',
    link: location.href, // 链接URL
    imgUrl: 'https://picbed.qunarzz.com/3c1f968718f9e443aa2e772ddce51b75.png', // 分享图标
  });
  if (callback) {
    if (hysdk.sniff.scheme) {
      hysdk.showShareItems({
        success: function () {
          // 用户点击了分享dialog中的分享按钮
          // do something
        }
      });
    } else {
      callback && callback();
    }
  }
}

export function goUrl(url: any, linkId: any) {
  window._hmt.push(["_trackPageview", "/#/linkId_" + linkId]);
  location.href = url;
}


/***********微信浏览器隐藏分享功能**************/

function onBridgeReady() {
  WeixinJSBridge.call('hideOptionMenu');
}

/* 分享函数 */
function hideWxShareInit() {
  let attachEvent = (document as any).attachEvent;
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (attachEvent) {
      attachEvent('WeixinJSBridgeReady', onBridgeReady);
      attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}

/* 根据浏览器 */
export function hideShare() {

  if (!isWxBrower()) {/* 非微信浏览器不做处理 */
    return;
  }
  hideWxShareInit();

}

export function callShareDialog() {
  if (hysdk.sniff.scheme) {
    hysdk.showShareItems({
      success: function () {
        // 用户点击了分享dialog中的分享按钮
        // do something
      }
    });
  } else {
    shareDialog();
  }

}

export function shareImage(link: string, shareType: string, successCb: any) {
  window._hmt.push(["_trackPageview", "/#/share_" + shareType || 'WechatFriends']);
  if (hysdk.sniff.scheme) {
    hysdk.share.shareToPlatform({
      shareType: shareType || 'WechatFriends',
      linkUrl: link,
      imageUrl: 'https://picbed.qunarzz.com/8dc2f840ef19fe56e2d31018145c5daf.jpg',
      title: '东风标致508L',
      text: '都市奇驭记 寻找你专属的感官旅行',
      options: {},
      success: function () {
        successCb && successCb();
      },
      fail: function () {
        //alert(JSON.stringify(err))
      }
    });
  } else {
    shareDialog();
  }
}

export function WechatTimeline(link: string, imageUrl: string, shareTitle: any, desc: any, callback: any) {
  hysdk.share.shareToPlatform({
    shareType: 'WechatTimeline',
    linkUrl: link,
    imageUrl: imageUrl,
    title: shareTitle,
    text: desc,
    options: {},
    success: function () {
      callback && callback();
    },
    fail: function () {
      callback && callback();
    }
  });
}


/***********************************************/

export function jumpToNote(id: any) {/* 跳转到游记 */
  window._hmt.push(["_trackPageview", "/#/jumpToNote_" + id]);
  if (hysdk.sniff.scheme) {
    location.href = hysdk.sniff.scheme + `://react/open?hybridId=in_gonglue_guide_rn&pageName=TravelNotesDetail&initProps=${encodeURIComponent(JSON.stringify({ "param": { "planId": id } }))}`
  } else {
    location.href = "https://travel.qunar.com/travelbook/note/" + id
  }
}

export function jumpToSight(id: string) {/* 跳转到景区 */
  window._hmt.push(["_trackPageview", "/#/jumpToSight_" + id]);
  if (hysdk.sniff.scheme) {
    location.href = hysdk.sniff.scheme + `://vacation/detail?pId=${id}`
  } else {
    location.href = 'https://aaag9.package.qunar.com/user/detail.jsp?abt=a&id=' + id + '&'
  }
}

/**
 * 初始化
 */

initConfig();